// lib/schema/organisation.ts

export const organisationSchema = {
    "@context": "https://schema.org",
    "@type": "ProfessionalService",
    "name": "Constellation Training",
    "url": "https://constellationtraining.co.uk",
    "description": "Constellation Training delivers accredited workplace training across London, Surrey, Sussex, Kent, and Hampshire, specialising in health & safety, first aid, and mental health first aid courses.",
    "telephone": "+443331887020",
    "email": "info@constellationtraining.co.uk",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "89 Bickersteth Rd",
      "addressLocality": "London",
      "addressRegion": "Greater London",
      "postalCode": "SW17 9SH",
      "addressCountry": "GB"
    },
    "areaServed": [
      { "@type": "Place", "name": "London" },
      { "@type": "Place", "name": "Surrey" },
      { "@type": "Place", "name": "Sussex" },
      { "@type": "Place", "name": "Kent" },
      { "@type": "Place", "name": "Hampshire" },
      { "@type": "Place", "name": "Essex" },
    ],
    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": [
          "Monday", "Tuesday", "Wednesday", "Thursday", "Friday"
        ],
        "opens": "08:00",
        "closes": "18:00"
      }
    ],
    "sameAs": [
      "https://www.linkedin.com/company/constellation-training",
      "https://www.facebook.com/constellationtraining"
    ]
  };

   //   "credential": [
  //   "Approved Qualsafe Training Centre",
  //   "Registered CPD Provider",
  //   "Highfield Approved Centre"
  // ]
  